import Avatar from "components/Avatar/Avatar";
import { useOrganiseList } from "context/OrganiseListContext";
import React, { useState } from "react";
import { ReactComponent as AddIcon } from "assets/icons/add_icon.svg";
import InputDialog from "components/Dialog/InputDialog";
import { isValidateEmail } from "utils/commonUtils";
import RemoveWarningDialog from "components/Dialog/RemoveWarningDialog";
import { Tooltip } from "react-tooltip";
import { ReactComponent as InfoIcon } from "assets/icons/info_2.svg";
import { Tooltip as ReactTooltip } from "react-tooltip";

const AvatarList = () => {
  const {
    selectedOrganiseList,
    organiseLists,
    shareOrganiseList,
    removeUserFromSharedList,
    sharedWithLoading,
  } = useOrganiseList();
  const [userEmail, setUserEmail] = useState("");
  const [validationError, setValidationError] = useState(false);
  const [isShareWithUserDialogOpen, setIsShareWithUserDialogOpen] =
    useState(false);
  const [isUserRemovePopupOpen, setIsUserRemovePopupOpen] = useState(false);
  const [userToRemove, setUserToRemove] = useState(null);

  // Share origanise list function
  const hanleShareWithUser = async () => {
    const isValid = isValidateEmail(userEmail);
    if (!isValid) {
      setValidationError("Email non valido. Riprova");
      setTimeout(() => {
        setValidationError("");
      }, 5000);
      return;
    }
    await shareOrganiseList(userEmail);
    setIsShareWithUserDialogOpen(false);
    setUserEmail("");
  };

  // Handle share dialog email input change
  const handleInputChange = (e) => {
    setUserEmail(e.target.value);
  };

  //  Remove user from shared with list
  const handleRemoveUserFromSharedList = async () => {
    if (userToRemove) {
      await removeUserFromSharedList(userToRemove);
      setIsUserRemovePopupOpen(false);
      setUserToRemove(null);
    }
  };

  // Find out shared with user list
  const sharedWith =
    organiseLists.length > 0 &&
    organiseLists?.find((list) => list._id === selectedOrganiseList._id)
      ?.sharedWith;

  if (!sharedWith) return;

  const totalAvatars = sharedWith.length || 0;

  // Group avatars into rows of 5
  const rows = [];
  for (let i = 0; i < totalAvatars; i += 5) {
    rows.push(sharedWith.slice(i, i + 5));
  }

  return (
    <>
      <div className="border h-[155px] border-[#EEEEEE] rounded-[10px] col-span-4 md:col-span-1 ">
        {totalAvatars > 0 ? (
          <div className="pb-[18px] px-[11px] flex flex-col justify-between items-center relative sm:ml-[13px] lg:ml-0 h-full">
            <span
              className="cursor-pointer absolute top-2 right-2"
              data-tooltip-id="avatar_info_tooltip"
              data-tooltip-content="Puoi condividere le liste solo con utenti che si sono iscritti ad HouseScan. Una volta iscritto lo potrai aggiungere alla lista."
            >
              <InfoIcon width={15} height={15} />
            </span>
            <div className="flex-1 flex flex-col items-center justify-center max-w-[122px] overflow-hidden">
              {rows.map((row, rowIndex) => (
                <div
                  key={rowIndex}
                  className="flex items-center justify-center"
                >
                  {row.map(({ _id, avatar, username }, index) => (
                    <Avatar
                      key={_id}
                      id={_id}
                      avatar={avatar}
                      username={username}
                      index={index}
                      totalAvatars={row.length}
                      onAvatarClick={(val) => {
                        setUserToRemove(val);
                        setIsUserRemovePopupOpen(true);
                      }}
                    />
                  ))}
                  {/* Avatar tooltip  */}
                  <Tooltip
                    id="avatar_tooltip"
                    place="top"
                    className="!max-w-64 !z-10 !text-sm !text-gray-500 !bg-white border !border-gray-200 !rounded-lg !shadow-sm"
                  />
                </div>
              ))}
            </div>
            <div
              onClick={() => setIsShareWithUserDialogOpen(true)}
              className="bg-primary h-[26px] rounded-[5px] relative cursor-pointer w-full flex items-center px-[6px] justify-center"
            >
              <div className="w-[17px] h-[17px] rounded-full absolute left-[6px] top-1/2 -translate-y-1/2 grid place-content-center bg-white text-primary">
                <AddIcon className="w-4" />
              </div>
              <p className="text-[#F2F2F2] text-[12px] font-normal">
                Condividi
              </p>
            </div>
          </div>
        ) : (
          <div
            onClick={() => setIsShareWithUserDialogOpen(true)}
            className="bg-primary h-full w-full relative rounded-[10px] text-white flex items-center justify-center flex-col gap-y-6"
          >
            <span
              className="cursor-pointer absolute top-2 right-2"
              data-tooltip-id="avatar_info_tooltip"
              data-tooltip-content="Puoi condividere le liste solo con utenti che si sono iscritti ad HouseScan. Una volta iscritto lo potrai aggiungere alla lista."
            >
              <InfoIcon width={15} height={15} fill="white" />
            </span>
            <div className="w-[47px] cursor-pointer h-[47px] rounded-full grid place-content-center bg-white text-primary">
              <AddIcon className="w-[35px] h-[35px]" />
            </div>
            <h2 className="text-white text-center font-semibold text-[15px] leading-6">
              Condividi Lista
            </h2>
          </div>
        )}
        {/* Info Tooltip  */}
        <ReactTooltip
          id="avatar_info_tooltip"
          place="top"
          positionStrategy="fixed"
          className="!max-w-64 !z-10 !text-sm !text-gray-500 !bg-white border !border-gray-200 !rounded-lg !shadow-xs"
        />
      </div>

      <RemoveWarningDialog
        warningText={`Sei sicuro di voler eliminare il profilo di MAIL dalla tua lista condivisa?`}
        isOpen={isUserRemovePopupOpen}
        isClose={() => {
          setUserToRemove(null);
          setIsUserRemovePopupOpen(false);
        }}
        loading={sharedWithLoading}
        onClick={handleRemoveUserFromSharedList}
      />
      <InputDialog
        placeholder="email"
        buttonText="Aggiungi Utente"
        label="Aggiungi utente alla lista"
        value={userEmail}
        validationError={validationError}
        isOpen={isShareWithUserDialogOpen}
        isClose={() => setIsShareWithUserDialogOpen(false)}
        onClick={hanleShareWithUser}
        onChange={handleInputChange}
        loading={sharedWithLoading}
      />
    </>
  );
};

export default AvatarList;
